import React from 'react';
import StepOneLogin from './pages/StepOneLogin';
import AuthHeader from '../../components/header/AuthHeader';
import BannerRight from '../../components/BannerRight';
import AuthWrapper from '../../components/AuthWrapper';
import Alert from '../../components/Alert';
import { useTrackingContext } from '../../context/trackingContext';
import Footer from '../../components/Footer';

const Login = () => {
  const { alert, setAlert } = useTrackingContext();

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="w-full lg:w-1/2 relative overflow-y-scroll left-form">
        <AuthHeader />
        <AuthWrapper className="max-w-sm">
          <StepOneLogin />
        </AuthWrapper>
        {alert === 'passwordReset' && (
          <Alert setShowAlert={setAlert}>
            <p className="pr-12 text-sm md:text-base">
              Your password has been successfully updated.
            </p>
          </Alert>
        )}
        <Footer />
      </div>
      <BannerRight />
    </div>
  );
};

export default Login;
